<template>
  <Layout header-class="header-left-align" nav-alignment="left">
    <Separator />
    <div class="">
      <div
        class="rn-service-area rn-section-gap"
        :class="{
          '': userLogin === false,
          ' background-pros-lightmode': userLogin === true
        }"
      >
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <SectionTitle
                text-align="center"
                :subtitle="$t('Home.let_summarize_subtitle')"
                style="text-align: "
                :title="$t('Home.pros_cons_title')"
                description=""
                data-aos="fade-up"
              />
              <div data-aos="fade-up">
                <ul>
                  <li>
                    {{ $t('Implementation.desc1') }}
                  </li>
                  <li>
                    {{ $t('Implementation.desc2') }}
                  </li>
                  <li>
                    {{ $t('Implementation.desc3') }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div>
            <serviceimplementation
              service-style="service__style--1 icon-circle-style"
              text-align="center"
              icon-size="39"
            />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from '../../components/common/Layout'
import SectionTitle from '../../components/elements/sectionTitle/SectionTitle'
import Separator from '../../components/elements/separator/Separator'
import serviceimplementation from '../../components/elements/service/serviceimplementation'

export default {
  name: 'Implementation',
  components: { Layout, SectionTitle, Separator, serviceimplementation },
  computed: {
    userLogin() {
      return this.$store.state.userLogin
    }
  }
}
</script>
<style>
.background-pros-lightmode {
  background-image: url(../../assets/images/Newlandindpage/lightmode/Group_27997@2x.png);
  background-size: cover;
  background-position: 15% 0%;
  /* background-repeat: no-repeat; */
  z-index: 10;
  width: 100%;
  height: 10%;
}

.background-impenmentation-light {
  background-image: url(../../assets/images/Newlandindpage/lightmode/Group_27997@2x.png);
  background-size: cover;
  background-position: -0% 0%;
  /* background-repeat: no-repeat; */
  background-position: center;
  position: absolute;
  background-attachment: fixed;
  z-index: 1;
  width: 100%;
  height: auto;
}
</style>
